import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { pluralize } from '@warp-drive/utilities/string';
import { load } from 'ember-async-data';
import cannot from 'ember-can/helpers/cannot';
import AbilitiesService from 'ember-can/services/abilities';
import { t } from 'ember-intl';
import { type Link, link } from 'ember-link';
import { or } from 'ember-truth-helpers';

import BreadcrumbService from 'umg-ember-backend/services/breadcrumb';
import { getBem } from 'umg-ember-backend/utils/get-bem';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import styles from './styles.module.css';

const bem = getBem(styles);

interface LinkToDetailSignature {
  Args: {
    model: TODO;
    isDisabled?: boolean;
  };
  Blocks: {
    default: [];
  };
}

export default class UiLinkToDetailComponent extends Component<LinkToDetailSignature> {
  // Service
  @service declare breadcrumb: BreadcrumbService;
  @service declare abilities: AbilitiesService;

  // Functions
  getDetailRouteName = (model: TODO) => {
    const recordType = getRecordType(model);
    const action = model.isNew ? 'new' : recordType;

    return `admin.${pluralize(recordType)}.${action}`;
  };

  get isDisabled() {
    const { model, isDisabled } = this.args;

    return isDisabled || this.abilities.cannot('read', model);
  }

  registerAndTransiton = (link: Link, event: PointerEvent) => {
    event.preventDefault();

    this.breadcrumb.registerDetailRoute(this.args.model);
    link.transitionTo();
  };

  // Template
  <template>
    {{#let (load @model) as |result|}}
      {{#if result.isResolved}}
        {{#if (or @isDisabled (cannot 'read' result.value))}}
          {{yield}}
        {{else}}
          {{#let
            (link (this.getDetailRouteName result.value) result.value.id)
            as |link|
          }}
            <a
              href={{link.url}}
              class={{bem (hash is-active=link.isActive)}}
              {{on 'click' (fn this.registerAndTransiton link)}}
            >
              {{yield}}
            </a>
          {{/let}}
        {{/if}}
      {{else if result.isPending}}
        {{t 'ui.loading'}}
      {{/if}}
    {{/let}}
  </template>
}
